// Confidentialite.js
import React from 'react';
import './PageContainer.css';


function Confidentialite() {
  return (
    <div className="page-container">
      <h1>Politique de confidentialité</h1>
      <h2>Données collectées :</h2>
      <ul>
        <li>Nom, prénom</li>
        <li>Email, téléphone</li>
        <li>Informations de réservation ou de projet immobilier</li>
      </ul>
      <h2>Finalité :</h2>
      <ul>
        <li>Traitement de vos demandes</li>
        <li>Envoi de confirmations ou de propositions</li>
        <li>Amélioration de nos services</li>
      </ul>
      <h2>Sécurité :</h2>
      <ul>
        <li>Données stockées sur des serveurs sécurisés</li>
        <li>Accès limité à l’équipe autorisée uniquement</li>
      </ul>
      <h2>Durée de conservation :</h2>
      <p>3 ans après la dernière interaction client</p>
      <h2>Vos droits :</h2>
      <ul>
        <li>Droit d’accès, de rectification, de suppression</li>
        <li>Demande par email : <a href="mailto:cicjimmo@gmail.com">cicjimmo@gmail.com</a></li>
      </ul>
    </div>
  );
}

export default Confidentialite;